export class StorageHandlerService {
    public static get(name: string): string {
        const value = sessionStorage.getItem(name);
        if (value != null) {
            return value;
        } else {
            return '';
        }
    }

    public static set(name: string, value: string): void {
        sessionStorage.setItem(name, value);
    }

    public static setCookie(name: string, value: string, expire?: string, path?: string): void {
        const domain = window.location.hostname;
        const now = new Date();
        const minutes = 60;
        now.setTime(now.getTime() + (minutes * 60 * 1000));
        if (domain === 'localhost') {
            document.cookie = name + '=' + value + '; expires= ' + now.toUTCString() + ' ; path=/' ;
        } else {
            document.cookie = name + '=' + value + '; expires= ' + now.toUTCString() + ' ; path=/; secure' ;
        }
    }

    public static getCookie(name: string): string {
        // const cookies = document.cookie.split(';');
        // let finalCookie = '';
        // cookies.forEach((val, index) => {
        //     const cookieval = val.trim().split('=');
        //     if (cookieval[0] === name) {
        //         finalCookie = cookieval[1];
        //     }
        // });
        // return finalCookie;

        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return (match) ? match[2] : '';
    }

    public set(name: string, value: string): void {
        sessionStorage.setItem(name, value);
    }

    public static deleteCookie(name: string) {
        const domain = window.location.hostname;
        if (domain === 'localhost') {
            document.cookie = name + '= ; path=/ ; max-age=0';
        } else {
            document.cookie = name + '= ; path=/; secure; max-age=0;';
        }
    }

}
